var path = 'app/reporting/site_specific/hardlinkVisitors.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;